module.exports = __webpack_public_path__ + "static/media/fiscal_ice_may25.fdc31ac9.csv";